import forEach from 'dcode/functions/forEach'
import getPostLink from '@/functions/getPostLink'
import getSlug from '@/functions/getSlug'
import Translation from 'dcode/classes/Translation'

export default function getNavigation (basic) {
  const data = [...basic?.main]

  if (
    basic?.other &&
    basic?.other.length > 0
  ) {
    data.push({ space: true })
    data.push({ subtitle: Translation.get('Other topics') })
    data.push(...basic.other)
  }

  return forEach(
    data,
    item => {
      if (
        'value' in item &&
        item.list?.length > 0
      ) {
        const data = {
          icon: item.icon,
          text: item.text,
          value: item.value,
          isCategory: true
        }

        if (item.list?.length > 0) {
          data.list = forEach(item.list, item => {
            return {
              href: getPostLink(item, true),
              to: getPostLink(item),
              icon: 'none',
              text: item.text,
              value: item.value,
              slug: item.slug || getSlug(item.text)
            }
          })
        }

        return data
      } else {
        return item
      }
    }
  )
}
